import { render, staticRenderFns } from "./ProductMetadata.vue?vue&type=template&id=5a9fb09e&"
import script from "./ProductMetadata.vue?vue&type=script&lang=js&"
export * from "./ProductMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9fb09e')) {
      api.createRecord('5a9fb09e', component.options)
    } else {
      api.reload('5a9fb09e', component.options)
    }
    module.hot.accept("./ProductMetadata.vue?vue&type=template&id=5a9fb09e&", function () {
      api.rerender('5a9fb09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ProductMetadata/ProductMetadata.vue"
export default component.exports